import { render, staticRenderFns } from "./registriesMain.vue?vue&type=template&id=12f44f18&scoped=true&"
import script from "./registriesMain.vue?vue&type=script&lang=js&"
export * from "./registriesMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12f44f18",
  null
  
)

export default component.exports